<div *ngIf="activeFileRecord">
    <tbody class="submInfo-container" >
        <tr>
            <td class="category">Sample ID</td>
            <td class="val">{{activeFileRecord.sampleID}}</td>
        </tr>
        <tr>
            <td class="category">Status </td>
            <td class="val">{{activeFileRecord.sampleStatus}}</td>
        </tr>
    </tbody>
    <div class="sub-head">Submission Info</div>
    <tbody class="submInfo-container">
        <tr>
            <td class="category">HML ID</td>
            <td class="val"><em class="material-icons dash-link-icon">link</em><span class="click-me" matTooltip={{activeFileRecord.hmlId}}  (click)="displaySourceDialog(activeFileRecord.docIDGUID, activeFileRecord.hmlId, activeFileRecord.fileName, activeFileRecord.statusCde)">{{activeFileRecord.hmlId}}</span></td>
        </tr>
        <tr>
            <td class="category">Reporting Center </td>
            <td class="val">{{activeFileRecord.reportingCenter}}</td>
        </tr>
        <tr>
            <td class="category">Received (CST) </td>
            <td class="val">{{activeFileRecord.receivedDate}}</td>
        </tr>
        <tr>
            <td class="category">Status </td>
            <td class="val">{{activeFileRecord.statusCde}}</td>
        </tr>
        <tr>
            <td class="category">Step Code </td>
            <td class="val">{{activeFileRecord.stepCde}}</td>
        </tr>
        <tr>
            <td class="category">Description </td>
            <td class="val">{{activeFileRecord.processDesc}}</td>
        </tr>
        <tr>
            <td class="category">Application </td>
            <td class="val">{{activeFileRecord.applicationName}}</td>
        </tr>
    </tbody>
    <mat-icon matTooltip="Copy UUID" class="icon copy rotate" (click)="copyMessage($event, activeFileRecord.docIDGUID)">content_copy</mat-icon>
</div>
